import { useMemo } from "react";
import { renderWithRedactions } from "./TextFormatter";

// Renders a long-form article with inline [n] citations linked to sources.
export const FullArticle = ({ article, sources = [] }) => {
        const paragraphs = useMemo(
                () => (article || "").split(/\n+/).map((p) => p.trim()).filter(Boolean),
                [article]
        );

        if (!paragraphs.length) return null;

        const renderText = (text) => renderWithRedactions(text, sources);

        const lead = paragraphs[0];
        const rest = paragraphs.slice(1);

        return (
                <article className="font-serif text-[19px] leading-[1.85] text-[var(--ink)]">
                        <p
                                className="text-2xl md:text-[26px] leading-[1.5] mb-8 first-letter:text-7xl first-letter:font-bold first-letter:float-left first-letter:mr-3 first-letter:mt-2 first-letter:leading-none first-letter:text-[var(--controversy)]"
                        >
                                {renderText(lead)}
                        </p>
                        {rest.map((p) => (
                                <p key={p} className="mb-6">
                                        {renderText(p)}
                                </p>
                        ))}
                </article>
        );
};

export default FullArticle;
